import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../MainStyle.css';
import ToastDialog from '../dialogs/ToastDialog';
import { API_GET_PROFILE, API_UPDATE_ACCOUNT } from '../modals/Constants';
import HeaderView from "../other-components/HeaderView/view";
import { getStorage, setStorage } from '../modals/Storage';
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";

function UpdateProfile() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [inEmailId, setInEmailId] = useState("");
    const [inMobileNum, setInMobileNum] = useState("");
    const [inFullName, setInFullName] = useState("");
    const [inPassword, setInPassword] = useState("");

    const [pageConst, setConstants] = useState({
        toastDialogShow: false,
        toastTimeAvail: 7,
        toastMessage: "",
    });

    const updateToastDialogState = (data, msg) => {
        setConstants(previousState => {
            return { ...previousState, toastDialogShow: data }
        });

        setConstants(previousState => {
            return { ...previousState, toastMessage: msg }
        });
    }

    const updateAccount = () => {
        const requestAPI = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getStorage("accountSecret")}`,
                    },
                    body: JSON.stringify(formData),
                });

                const response = await res.json();
                setLoading(false);

                if (response.status_code === "success") {
                    navigate("/account", { replace: true });
                } else {
                    updateToastDialogState(true, "There was a technical issue! Please try again!");
                }
            } catch (error) {
                setLoading(false);
                updateToastDialogState(true, "There was a technical issue! Please try again!");
            }
        };

        if (inMobileNum != "" && inFullName != "" && inPassword) {
            setLoading(true);
            const formData = {
                ACCOUNT_ID: getStorage("accountID"),
                ACCOUNT_EMAIL: inEmailId,
                ACCOUNT_MOBILE: inMobileNum,
                ACCOUNT_FULLNAME: inFullName,
                ACCOUNT_PASSWORD: inPassword,
                IS_FORCED_UPDATE: true
            };
            requestAPI(API_UPDATE_ACCOUNT, formData);
        }
    }

    const getRecords = () => {
        const requestAPI = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getStorage("accountSecret")}`,
                    },
                    body: JSON.stringify(formData),
                });

                const response = await res.json();
                setLoading(false);

                if (response.status_code == "success") {
                    setInFullName(response.data.username);
                    setInEmailId(response.data.email);
                    setInMobileNum(response.data.mobile);
                }
            } catch (error) {
                setLoading(false);
                updateToastDialogState(true, "There was a technical issue! Please try again!");
            }
        };

        setLoading(true);
        const formData = { ACCOUNT_ID: getStorage("accountID"), ONBOARD: true };
        requestAPI(API_GET_PROFILE, formData);
    }

    useEffect(() => {
        if (getStorage("accountID") == '' || getStorage("accountSecret") == '') {
            navigate('/signin', { replace: true });
        } else {
            getRecords()
        }
    }, []);

    return (
        <div className={[general.appView]}>
            <ToastDialog intentData={pageConst} updateState={updateToastDialogState} />
            <LoadingDialog
                isOpen={loading}
            />

            <div className={[general.appChildView]}>
                <HeaderView screen={"profile"} />

                <div className={general.appLocationViews}>
                    <p>Update profile</p>
                </div>

                <div className={[general.appContentsView]}>
                    <div className={[screen.profileView].join(" ")}>
                        <div>
                            <span className='ft-sz-13'>Full Name</span>
                            <div className={general.inpBoxOutline}>
                                <input type="text" autoComplete="new-password" value={inFullName} onChange={e => setInFullName(e.target.value)}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>Email Id (optional)</span>
                            <div className={general.inpBoxOutline}>
                                <input type="text" autoComplete="new-password" value={inEmailId} onChange={e => setInEmailId(e.target.value)} readOnly={true}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>Mobile</span>
                            <div className={general.inpBoxOutline}>
                                <input type="number" autoComplete="new-password" value={inMobileNum} onChange={e => setInMobileNum(e.target.value)} readOnly={true}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>Password</span>
                            <div className={general.inpBoxOutline}>
                                <input type="password" autoComplete="new-password" onChange={e => setInPassword(e.target.value)}></input>
                            </div>
                        </div>
                    </div>

                    <button className={[general.primaryBtn, general.rounded1x].join(" ")} onClick={() => updateAccount()}>Update profile</button>
                </div>
            </div>
        </div>
    );
}

export default UpdateProfile;